<template>
    <div class="area-guide-success">
        <div class="hero-banner">
            <div class="container text-center white--text">
                <v-row
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-14"
                >
                    <v-col cols="12" lg="7" class="pa-lg-0">
                        <h1>Thanks for Downloading the {{capitalizedGuideName}} Area Guide!</h1>
                    </v-col>
                </v-row>

                <v-row
                    v-if="showEmailDetails"
                    justify="center"
                    class="ma-0 mb-4 mb-md-8 mb-lg-14"
                >
                    <v-col cols="10" sm="8" md="7" lg="6" class="pa-lg-0">
                        <p>
                            Here's your free downloadable! If you'd like to access your area guide later, head to
                            your email inbox, where a copy has been sent so you can download it whenever your ready.
                        </p>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="call-to-action row-reverse">
            <div class="content">
                <v-row class="py-2">
                    <v-col cols="12" md="6" lg="5" class="px-0">
                        <h2>Learn More About EDUrent</h2>
                        <div class="mt-3">
                            <p>
                                Whether you're looking for an affordable apartment in {{capitalizedGuideName}}, new roommates,
                                or a way to crowdfund your expenses while in school, we've got you covered at EDUrent.
                                Explore our student resources to learn more.
                            </p>
                        </div>
                        <v-btn
                            color="primary"
                            depressed
                            to="/about"
                        >
                            <span>Learn More About EDUrent</span>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" lg="6" class="d-none d-lg-block"></v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AreaGuideSuccess',

    props: {
        guideName: {
            type: String,
            default: undefined,
        },
    },

    data() {
        return {
            showEmailDetails: false,
        };
    },

    computed: {
        capitalizedGuideName() {
            return this.guideName.charAt(0).toUpperCase() + this.guideName.slice(1);
        },
    },

    beforeMount() {
        // Set the menu to transparent
        this.$store.commit('setHeaderMenuState', 'transparent');
    },
};
</script>

<style scoped>
/** Generic Page styles */
>>>.content>.row {
    width: 100%;
    margin: 0;
}

div.area-guide-success {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

div.area-guide-success .v-btn {
    text-transform: none;
    font-weight: bold;
}

div.hero-banner .container,
div.call-to-action .content {
    width: 90%;
    max-width: 1505px;
    padding: 0 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 2;
}

/** Hero Banner styles */
div.hero-banner {
    padding-top: 250px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    max-height: 800px;
    min-height: 780px;
    background-image: url("../../src/assets/media/area-guide-success-header.jpg");
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

div.hero-banner:before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(10, 10, 10, 0.75);
    z-index: 1;
}

div.hero-banner h1 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 64px;
    line-height: 72px;
    max-width: 1300px;
    margin: auto;
    margin-top: 4.3%;
}

/** Call to Action section styles */
div.call-to-action {
    background-size: 55% auto !important;
    background-position: left top 10% !important;
    background: url("../../src/assets/media/smiling-woman-using-laptop.png"), #ffffff;
    background-repeat: no-repeat !important;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 6% 0;
}

div.call-to-action:before {
    position: absolute;
    content: '';
    top: 0;
    right: 44%;
    width: 35%;
    height: 100%;
    background: -webkit-gradient(linear, right top, left top, from(#ffffff), to(rgba(55, 62, 85, 0)));
    background: -o-linear-gradient(right, #ffffff 0%, rgba(55, 62, 85, 0) 100%);
    background: linear-gradient(270deg, #ffffff 0%, rgba(55, 62, 85, 0) 100%);
}

div.call-to-action .row {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

div.call-to-action.row-reverse .row {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
}

div.call-to-action h2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 1.5;
    margin: 0 auto;
    color: #000000;
}

div.call-to-action p {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    padding-bottom: 2rem;
    color: #000000;
}

div.call-to-action .v-btn {
    height: 45px;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: normal;
    text-transform: capitalize;
}

@media (max-width: 1400px) {
    div.hero-banner h1 {
        font-size: clamp(30px, 3em, 64px);
        line-height: 1.125;
    }

    div.call-to-action {
        background-size: cover !important;
    }

    div.call-to-action:before {
        right: 0;
        width: 100%;
        background: -webkit-gradient(linear, right top, left top, color-stop(40%, #FFFFFF), to(rgba(55, 62, 85, 0)));
        background: -o-linear-gradient(right, #FFFFFF 40%, rgba(55, 62, 85, 0) 100%);
        background: linear-gradient(270deg, #FFFFFF 40%, rgba(55, 62, 85, 0) 100%);
    }
}

@media (max-width: 1264px) {
    div.hero-banner {
        max-height: 720px;
        min-height: 630px;
        padding-top: 170px;
    }
}

@media (max-width: 1024px) {
    div.hero-banner {
        padding: 0;
    }

    div.hero-banner .container,
    div.call-to-action .content {
        margin-top: auto;
        margin-bottom: auto;
        height: 100%;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }

    div.hero-banner h1 {
        font-size: clamp(30px, 3em, 50px);
        padding-left: 0;
        padding-right: 0;
    }

    div.call-to-action {
        padding: 50px 0;
    }

    div.call-to-action:before {
        left: 0;
        right: 0;
        width: 100%;
        background: -webkit-gradient(linear, right top, left top, color-stop(15%, #FFFFFF), to(rgba(55, 62, 85, 0.5)));
        background: -o-linear-gradient(right, #FFFFFF 15%, rgba(55, 62, 85, 0.5) 100%);
        background: linear-gradient(270deg, #FFFFFF 15%, rgba(55, 62, 85, 0.5) 100%);
        -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
    }

    div.call-to-action .row .col-12:first-child {
        margin-right: auto;
    }
}

@media (max-width: 768px) {
    div.hero-banner .container,
    div.call-to-action .content {
        max-width: 100%;
    }

    div.hero-banner {
        padding-top: 100px;
        padding-bottom: 70px;
        min-height: 200px;
        height: auto;
    }

    div.hero-banner h1 {
        font-size: clamp(30px, 2em, 64px);
    }
}

@media (max-width: 575px) {
    div.hero-banner h1 {
        font-size: 30px;
    }
}
</style>
